var _metadata, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWheelsArrows = function SvgWheelsArrows(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsdc: "http://purl.org/dc/elements/1.1/",
    xmlnscc: "http://creativecommons.org/ns#",
    xmlnsrdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnssvg: "http://www.w3.org/2000/svg",
    viewBox: "0 0 816 1056",
    height: 100,
    width: 100,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfabout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfresource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M 0,792 H 612 V 0 H 0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1056)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18)",
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(448.2695,344.8076)",
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,35.127 -28.578,63.705 -63.706,63.705 -35.127,0 -63.706,-28.578 -63.706,-63.705 0,-35.127 28.579,-63.705 63.706,-63.705 C -28.578,-63.705 0,-35.127 0,0 m 24.479,0 c 0,-48.704 -39.481,-88.187 -88.185,-88.187 -48.704,0 -88.186,39.483 -88.186,88.187 0,48.703 39.482,88.186 88.186,88.186 48.704,0 88.185,-39.483 88.185,-88.186"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(378.3594,336.2617)",
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -2.106,0 -3.813,-1.707 -3.813,-3.813 0,-2.107 1.707,-3.815 3.813,-3.815 2.106,0 3.814,1.708 3.814,3.815 C 3.814,-1.707 2.106,0 0,0 m 18.501,5.539 c -2.105,0 -3.813,-1.708 -3.813,-3.814 0,-2.107 1.708,-3.814 3.813,-3.814 2.106,0 3.814,1.707 3.814,3.814 0,2.106 -1.708,3.814 -3.814,3.814 m -5.302,19.535 c -2.106,0 -3.814,-1.708 -3.814,-3.814 0,-2.107 1.708,-3.814 3.814,-3.814 2.107,0 3.814,1.707 3.814,3.814 0,2.106 -1.707,3.814 -3.814,3.814 m -19.088,-4.9 c -2.106,0 -3.814,-1.708 -3.814,-3.815 0,-2.106 1.708,-3.813 3.814,-3.813 2.107,0 3.814,1.707 3.814,3.813 0,2.107 -1.707,3.815 -3.814,3.815 M 13.031,8.546 c 0,3.764 -3.062,6.826 -6.827,6.826 -3.764,0 -6.826,-3.062 -6.826,-6.826 0,-3.764 3.062,-6.826 6.826,-6.826 3.765,0 6.827,3.062 6.827,6.826 M 6.204,-14.84 c -12.895,0 -23.387,10.491 -23.387,23.386 0,12.894 10.492,23.386 23.387,23.386 C 19.1,31.932 29.591,21.44 29.591,8.546 29.591,-4.349 19.1,-14.84 6.204,-14.84"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(342.1025,384.1982)",
    id: "g28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 9.399,10.125 22.366,16.895 36.879,18.288 l 0.001,-0.469 3.687,-28.132 -10e-4,0.006 c -8.05,-0.518 -15.221,-4.321 -20.184,-10.078 l 0.006,-0.006 -20.485,20.489 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(328.4287,357.1787)",
    id: "g32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 27.896,-5.187 -0.011,0.002 c -0.585,-2.299 -0.897,-4.708 -0.897,-7.186 0,-5.536 1.552,-10.716 4.242,-15.129 l 0.013,0.007 -25.815,-13.151 0.107,0.054 c -4.678,8.356 -7.347,17.982 -7.347,28.219 0,4.319 0.476,8.529 1.376,12.581 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(395.7666,287.9492)",
    id: "g36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -3.625,-0.714 -7.371,-1.087 -11.203,-1.087 -10.688,0 -20.708,2.908 -29.313,7.975 l 0.201,0.406 13.553,24.927 -0.217,0.139 c 4.551,-2.94 9.967,-4.647 15.776,-4.647 2.303,0 4.544,0.268 6.694,0.775 l -0.005,0.024 4.531,-28.616 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(422.7051,301.8037)",
    id: "g40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -19.519,20.593 -0.054,-0.038 c 5.88,4.871 9.821,12.003 10.48,20.049 l -0.022,0.002 28.614,-4.534 -0.104,0.017 C 17.668,21.636 10.601,8.8 0.229,-0.384 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(437.249,367.7939)",
    id: "g44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -25.616,-12.2 0.007,0.003 c -2.9,7.25 -8.63,13.072 -15.818,16.093 l -0.01,-0.018 13.156,25.813 -0.052,-0.101 C -15.566,23.653 -5.309,13.2 0.376,0.297"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(287.9644,444.0439)",
    id: "g48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,35.127 -28.579,63.705 -63.706,63.705 -35.127,0 -63.706,-28.578 -63.706,-63.705 0,-35.127 28.579,-63.705 63.706,-63.705 C -28.579,-63.705 0,-35.127 0,0 m 24.48,0 c 0,-48.704 -39.482,-88.186 -88.186,-88.186 -48.704,0 -88.186,39.482 -88.186,88.186 0,48.704 39.482,88.186 88.186,88.186 C -15.002,88.186 24.48,48.704 24.48,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(218.0542,435.4985)",
    id: "g52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path54",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -2.106,0 -3.814,-1.708 -3.814,-3.814 0,-2.106 1.708,-3.813 3.814,-3.813 2.106,0 3.814,1.707 3.814,3.813 C 3.814,-1.708 2.106,0 0,0 m 18.501,5.539 c -2.106,0 -3.813,-1.708 -3.813,-3.814 0,-2.107 1.707,-3.814 3.813,-3.814 2.106,0 3.814,1.707 3.814,3.814 0,2.106 -1.708,3.814 -3.814,3.814 m -5.302,19.535 c -2.106,0 -3.814,-1.708 -3.814,-3.814 0,-2.107 1.708,-3.814 3.814,-3.814 2.106,0 3.814,1.707 3.814,3.814 0,2.106 -1.708,3.814 -3.814,3.814 M -5.889,20.173 c -2.107,0 -3.814,-1.707 -3.814,-3.814 0,-2.106 1.707,-3.814 3.814,-3.814 2.106,0 3.814,1.708 3.814,3.814 0,2.107 -1.708,3.814 -3.814,3.814 M 13.031,8.545 c 0,3.764 -3.063,6.827 -6.827,6.827 -3.764,0 -6.827,-3.063 -6.827,-6.827 0,-3.763 3.063,-6.826 6.827,-6.826 3.764,0 6.827,3.063 6.827,6.826 M 6.204,-14.84 c -12.895,0 -23.387,10.491 -23.387,23.385 0,12.895 10.492,23.386 23.387,23.386 C 19.1,31.931 29.591,21.44 29.591,8.545 29.591,-4.349 19.1,-14.84 6.204,-14.84"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(181.7969,483.4351)",
    id: "g56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path58",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 9.4,10.125 22.366,16.894 36.879,18.288 l 0.002,-0.469 3.686,-28.133 v 0.007 c -8.051,-0.519 -15.222,-4.321 -20.185,-10.078 l 0.006,-0.006 -20.485,20.488 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168.1235,456.4155)",
    id: "g60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path62",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 27.896,-5.187 -0.011,0.002 c -0.586,-2.3 -0.897,-4.708 -0.897,-7.187 0,-5.535 1.552,-10.715 4.242,-15.128 l 0.013,0.007 -25.815,-13.151 0.107,0.054 c -4.678,8.356 -7.347,17.981 -7.347,28.218 0,4.32 0.476,8.53 1.376,12.582 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(235.4614,387.1855)",
    id: "g64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path66",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -3.625,-0.713 -7.372,-1.087 -11.203,-1.087 -10.688,0 -20.708,2.908 -29.313,7.975 l 0.201,0.406 13.553,24.927 -0.216,0.139 c 4.55,-2.939 9.967,-4.647 15.775,-4.647 2.303,0 4.544,0.268 6.694,0.775 l -0.004,0.025 4.53,-28.617 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(262.4004,401.0405)",
    id: "g68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path70",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -19.519,20.593 -0.055,-0.038 c 5.88,4.871 9.822,12.002 10.48,20.048 l -0.022,0.003 28.615,-4.534 -0.105,0.016 C 17.667,21.636 10.6,8.8 0.228,-0.384 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(276.9434,467.0303)",
    id: "g72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path74",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -25.616,-12.2 0.007,0.004 c -2.899,7.249 -8.63,13.072 -15.817,16.093 l -0.01,-0.019 13.155,25.813 -0.052,-0.101 C -15.566,23.654 -5.308,13.201 0.376,0.297"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(452.0986,494.9775)",
    id: "g76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path78",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 24.558,20.93 -7.256,-111.069 -75.07,83.999 26.791,-2.232 c -25.395,30.418 -65.86,65.023 -159.349,53.302 l -6.139,29.302 C -88.465,90.698 -31.256,41.302 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(149.7837,300.0146)",
    id: "g80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path82",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -24.558,-20.931 7.256,111.071 75.069,-84 -26.79,2.232 c 25.395,-30.419 65.86,-65.023 159.348,-53.302 l 6.139,-29.302 C 88.465,-90.697 31.256,-41.302 0,0"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWheelsArrows, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wheels_arrows.9fc7e463.svg";
export { ForwardRef as ReactComponent };